import { defineComponent as _defineComponent } from 'vue'
import { cva } from 'class-variance-authority'
import { toRefs } from 'vue'
import { RouterLink } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppButtonIcon',
  props: {
  size: { default: 'md' },
  variant: { default: 'standard' },
  disabled: { type: Boolean, default: false },
  type: { default: 'button' },
  to: { default: '#' },
  transparent: { type: Boolean, default: false }
},
  emits: ["click", "mouseover", "mouseenter", "mouseleave"],
  setup(__props, { emit }) {

const props = __props;


const { size, variant, transparent } = toRefs(props)

const styles = cva(
  [
    'tw-inline-flex tw-flex-row tw-items-center tw-border-solid tw-justify-center tw-rounded-full tw-transition-all',
    'disabled:tw-cursor-not-allowed',
  ],
  {
    variants: {
      size: {
        sm: ['tw-h-9 tw-w-9', '[&>svg]:tw-h-5 [&>svg]:tw-w-5'],
        md: ['tw-h-10 tw-w-10', '[&>svg]:tw-h-6 [&>svg]:tw-w-6'],
        lg: ['tw-h-12 tw-w-12', '[&>svg]:tw-h-6 [&>svg]:tw-w-6'],
      },
      variant: {
        standard: [
          'tw-bg-surface-lightest',
          'hover:tw-bg-surface-medium',
          'active:tw-bg-secondary',
          'disabled:tw-bg-surface-lightest',
          '[&>svg]:tw-fill-neutral-dark [&>svg]:active:tw-fill-primary [&>svg]:disabled:tw-fill-body-2',
        ],
        filled: [
          'tw-bg-primary',
          'hover:tw-bg-primary-dark',
          'active:tw-bg-primary-darkest',
          'disabled:tw-bg-blue-gray-50',
          '[&>svg]:tw-fill-surface-lightest [&>svg]:disabled:tw-fill-body-2',
        ],
        outlined: [
          'tw-border tw-border-solid tw-border-outline-dark tw-bg-surface-lightest',
          'hover:tw-border-primary hover:tw-bg-secondary-light',
          'active:tw-bg-secondary',
          'disabled:tw-border-outline-light disabled:tw-bg-surface-lightest',
          '[&>svg]:tw-fill-neutral-dark [&>svg]:hover:tw-fill-primary [&>svg]:disabled:tw-fill-body-2',
        ],
      },
      transparent: {
        true: [],
        false: [],
      },
    },
    compoundVariants: [
      {
        variant: 'standard',
        transparent: true,
        class: ['tw-bg-transparent', 'disabled:tw-bg-transparent'],
      },
    ],
    defaultVariants: {
      size: 'md',
      variant: 'standard',
      transparent: false,
    },
  },
)



return { __sfc: true,props, size, variant, transparent, styles, emit, RouterLink }
}

})